export { default, type InfluencerCardProductDetails } from './InfluencerCard'
